module.exports = __webpack_public_path__ + "img/Polygon.67ac1b81.svg";